// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportTitleAndDescription.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Title And Description component
 */
!(function() {
  var m = require('mobx-react');
  var React = require('react');
  var EventsUtils = require('EventUtils');
  var reportDesignerWidget = require('share/components/hoc/Izenda.ReportDesignerWidget');
  var FormatItemPropertiesSchema = require('modules/ReportDesigner/Formats/Izenda.FormatItemSchema');
  var Input = reportDesignerWidget.wrapper(require('share/components/controls/Izenda.Input'));
  var TextArea = reportDesignerWidget.wrapper(require('share/components/controls/Izenda.TextArea'));
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Panel = require('share/components/controls/Izenda.Panel');
  var Label = require('share/components/controls/Izenda.Label');
  var FormatStyleUtils = require('share/utils/Izenda.FormatStyleUtils');
  var localizer = require('share/localization/Izenda.Localizer');
  var PROPS_EDITOR = [{
    name: 'formatItemProps',
    getDefinedSchema: FormatItemPropertiesSchema
  }];

  var TitleDescription = m.observer(function(props) {

    var store = props.store || {};
    var viewMode = props.viewMode;
    var afterToggled = props.afterToggled;
    var reportDesignerModel = store.model || {};
    var reportTitleDescription = reportDesignerModel.reportTitleDescription;
    var formatItems = reportTitleDescription.formatItems;
    var title = formatItems[0];
    var description = formatItems[1];

    var header = {
      title: localizer.getText('REPORTDESIGNER_TOOLTIP_REPORT_TITLE_AND_DESCRIPTION'),
      icon: 'icon-toggle-thick'
    };

    var handleOnMouseDown = function(item) {
      reportDesignerModel.updateFormatItem && reportDesignerModel.updateFormatItem(item, reportTitleDescription.name);
      props.onClick && props.onClick();
    };

    var handleChangeTitle = function(value) {
      title.updateValueByKey('value', value);
    };


    var handleChangeDescription = function(value) {
      description.updateValueByKey('value', value);
    };

    var renderTitle = function() {
      var style = FormatStyleUtils.getStyle(title);
      var backgroundColor = FormatStyleUtils.getBackgroundStyle(title);
      return viewMode
        ? (<div style={style }><span style={backgroundColor}>{title.value}</span></div>)
        : (
          <GridLayout.Row>
            <GridLayout.Col cols='3'><Label>{localizer.getText('COMMON_LABEL_TITLE')}</Label></GridLayout.Col>
            <GridLayout.Col cols='9'>
              <Input className='form-control'
                     itemData={title}
                     propsEditors={PROPS_EDITOR}
                     onClick={handleOnMouseDown.bind(this, title)}
                     value={title.value}
                     onChange={EventsUtils.notifyChange(handleChangeTitle, EventsUtils.INPUT)} />
            </GridLayout.Col>
          </GridLayout.Row>
        );
    }.bind(this);

    var renderDescription = function() {
      var style = FormatStyleUtils.getStyle(description);
      var backgroundColor = FormatStyleUtils.getBackgroundStyle(description);
      return viewMode
        ? (<div style={style }><span style={backgroundColor}>{description.value}</span></div>)
        : (
          <GridLayout.Row>
            <GridLayout.Col cols='3'><Label>{localizer.getText('COMMON_LABEL_DESCRIPTION')}</Label></GridLayout.Col>
            <GridLayout.Col cols='9'>
             <TextArea itemData={description}
                       className='form-control'
                       propsEditors={PROPS_EDITOR}
                       onClick={handleOnMouseDown.bind(this, description)}
                       value={description.value}
                       onChange={EventsUtils.notifyChange(handleChangeDescription, EventsUtils.INPUT)} />
            </GridLayout.Col>
          </GridLayout.Row>
        );
    }.bind(this);


    return viewMode
    ? (
        <div className='report-format-element u_paddingAll'>
          {renderTitle()}{renderDescription()}
        </div>
      )
    : (
        <Panel header={header}
               afterToggled={afterToggled}
               collapsible
               initState
               className='report-format-element'
               ref='reportElement'>
          <GridLayout className='u_paddingAll'>
            {renderTitle()}
            {renderDescription()}
          </GridLayout>
        </Panel>
      );
  });

  module.exports = TitleDescription;
}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/Izenda.ReportTitleAndDescription.jsx